export function removeWhiteSpace(tag: string) {
  return tag.toLowerCase().replace(/[^A-Za-z0-9#+]/g, '');
}
